/* eslint-disable import/prefer-default-export */
// Make sure test cases are passing when you make this change.
// packages\ispm\src\tests\unit-tests\utils\messages.test.ts
export const invertedMessages = {
  'The generated content may have errors or may not show at all.':
    'Ispm.ContentNotAccurate.lowConfidenceText',
  'What can I help you with?': 'Ispm.SaviChatInput.inputPlaceholder',
  'Loading Dashboard': 'Ispm.dashboard.loading',
  'This may take several seconds': 'Ispm.dashboard.loadingTitle',
  'Reset Chat': 'Ispm.chatOverlay.resetChat',
  'Sure, How can I help?': 'Ispm.chatOverlay.resetChatResponse',
  Close: 'Ispm.chatOverlay.closeTitle',
  'Savi Companion': 'Ispm.header.savi.resumeIcon',
  'Another Session in Progress': 'Ispm.SaviChat.tabsErrorModalTitle',
  'Another Copilot session is open in another tab. Close this session to navigate out of Copilot and continue, or close any duplicate tabs.':
    'Ispm.SaviChat.tabsErrorModalSubtitle',
  'Close Session': 'Ispm.SaviChat.tabsErrorModalButtonLabel',
  'Sorry, there was an error or interruption while processing your prompt. When the service becomes available again, you can either enter your original prompt or try a new one':
    'Ispm.systemError.message',
  'Sorry, there was an error or interruption while processing your prompt. You can either reprocess your original prompt or try a new one.':
    'Ispm.copilotError.message',
  'Service temporary unavailable.': 'Ispm.systemError.serviceUnavailableTitle',
  'There was an error while processing your prompt. Please try again later.':
    'Ispm.systemError.serviceUnavailableDescription',
  'Reprocess Request': 'Ispm.copilotError.reprocessRequest',
  'The generated content has too many errors and cannot be shown. Edit the SQL or try a different request for better results.':
    'Ispm.sqlError.description',
  "Content can't be displayed": 'Ispm.sqlError.title',
  'System Error Alert': 'Ispm.alertBanner.systemError',
  'Your data is being generated and will be available in the Downloads section of your profile menu when finished.':
    'Ispm.alertBanner.downloadPending',
  'Iframe container': 'Ispm.iframe.container',
  'Toggle button group for switching views': 'Ispm.dataPanel.toggler',
  'Data panel with sql and visualization content': 'Ispm.dataPanel',
  'Generating Content': 'Ispm.GeneratingContent.generatingContent',
  'retrieving data': 'Ispm.GeneratingContent.retrievingData',
  'Stop Processing': 'Ispm.GeneratingContent.stopProcessingButtonLabel',
  'Are you sure?': 'Ispm.GeneratingContent.modalTitle',
  'Stopping processing may result in a charge of credits. Do you still want to continue?':
    'Ispm.GeneratingContent.modalSubtitle',
  Cancel: 'Ispm.global.cancel',
  'Savi is always learning new things. Results may vary.':
    'Ispm.saviInput.description',
  'Generating SQL': 'Ispm.sidePanelLoadinfText.generatingSql',
  'Capturing user input': 'Ispm.sidePanelLoadinfText.capturingUserInput',
  'Identifying schema': 'Ispm.sidePanelLoadinfText.identifyingSchema',
  'Parsing parameters': 'Ispm.sidePanelLoadinfText.parsingParameters',
  'Constructing SQL query': 'Ispm.sidePanelLoadinfText.constructingSqlQuery',
  'Validating generated SQL':
    'Ispm.sidePanelLoadinfText.validatingGeneratedSql',
  'Generating Table Data': 'Ispm.sidePanelLoadinfText.generatingTableData',
  'Executing SQL': 'Ispm.sidePanelLoadinfText.executingSql',
  'Fetching data': 'Ispm.sidePanelLoadinfText.fetchingData',
  'Formatting data': 'Ispm.sidePanelLoadinfText.formattingData',
  'Transforming data': 'Ispm.sidePanelLoadinfText.transformingData',
  'Finalizing table': 'Ispm.sidePanelLoadinfText.finalizingTable',
  'Generating Chart': 'Ispm.sidePanelLoadinfText.GeneratingChart',
  'Selecting chart type': 'Ispm.sidePanelLoadinfText.selectingChartType',
  'Configuring chart': 'Ispm.sidePanelLoadinfText.configuringChart',
  'Mapping data': 'Ispm.sidePanelLoadinfText.mappingData',
  'Styling chart': 'Ispm.sidePanelLoadinfText.stylingChart',
  'Generating visualization':
    'Ispm.sidePanelLoadinfText.generatingVisualization',
  Copilot: 'Ispm.header.title',
  'Save to Dashboard': 'Ispm.chartPanel.dashboardIcon',
  'Add Chart': 'Ispm.chartPanel.addChart',
  'Loading Chart': 'Ispm.chartPanel.loaderTitle',
  'Save to the Intelligence Dashboard': 'Ispm.chartPanel.saveChart.userMessage',
  'Take me to Intelligence Dashboard': 'Ispm.chartPanel.saveChart.link',
  'This chart has been pinned to your dashboard':
    'Ispm.chartPanel.saveChart.responseMessage',
  'Copied to clipboard': 'Ispm.clipboardCopySuccessTitle',
  'The SQL code was copied to your clipboard. Paste it into SQL Lab to edit further.':
    'Ispm.clipboardCopySuccessDesc',
  'Dashboards unavailable. Try refreshing the page to connect to our dashboards list.':
    'Ispm.chartPnael.dashboardError',
  Refresh: 'Ispm.refresh',
  'New Chart': 'Ispm.chart.defaultTtitle',
  'New Table': 'Ispm.table.defaultTtitle',
  'SQL Error': 'Ispm.error.sql.defaultTtitle',
  'Low Confidence': 'Ispm.error.lowConfidence.defaultTtitle',
  'Take me to the Intelligence Dashboard': 'Ispm.saveChart.responseLink',
  'Number of records': 'Ispm.table.totalRecords',
} as const;
